import { render, staticRenderFns } from "./IntroducitonContent4.vue?vue&type=template&id=3066e65a&scoped=true"
import script from "./IntroducitonContent4.vue?vue&type=script&lang=js"
export * from "./IntroducitonContent4.vue?vue&type=script&lang=js"
import style0 from "./IntroducitonContent4.vue?vue&type=style&index=0&id=3066e65a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3066e65a",
  null
  
)

export default component.exports